import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 0C9.54 0 .958 8.03.076 18.26h39.848C39.042 8.03 30.46 0 20 0Zm0 40c10.46 0 19.042-8.03 19.924-18.26H.076C.958 31.97 9.54 40 20 40Z"
}, null, -1), d = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "m16.522 26.956-2.241 1.055 1.193 2.17-2.433-.466-.309 2.459-1.695-1.808-1.695 1.808-.308-2.459-2.434.466 1.194-2.17-2.241-1.055 2.24-1.054-1.193-2.17 2.434.466.308-2.459 1.695 1.808 1.695-1.808.309 2.459 2.433-.466-1.193 2.17 2.24 1.054Z"
}, null, -1), i = [
  n,
  s,
  c,
  d
];
function _(h, r) {
  return e(), l("svg", o, [...i]);
}
const u = { render: _ };
export {
  u as default,
  _ as render
};
